// extracted by mini-css-extract-plugin
export default {"AlignDeleteModal":"DeleteCardModal_AlignDeleteModal__lDeMR","AlignButtons":"DeleteCardModal_AlignButtons__nAW3+"};